import { useSelector } from 'react-redux';

export default () => {
  const { hasUserDetails } = useSelector(state => state.auth);

  return useIsAuthenticated() && hasUserDetails;
}

export function useIsAuthenticated() {
  const authenticated = localStorage.getItem('authenticated');
  const expiresAt = localStorage.getItem('expiresAt');

  return authenticated === "true" && expiresAt !== undefined;
}

